import { Component, Input, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { RestService } from "@stdoutsrl/design-kit"
import {  Message } from "@stdoutsrl/design-kit";
import { LoaderService } from "../../service/loader.service";

@Component({
  selector: "app-cube_game",
  templateUrl: "./cube_game.component.html",
  styles: [],
  standalone: false,
})
export class CubeGameComponent implements OnInit {
  constructor(
    private router: Router,
    private rest: RestService,
    private loader: LoaderService,
    private message: Message,
    private activatedRoute: ActivatedRoute,
  ) {}

  showGame = false

  ngOnInit(): void {
  }


}
